module.exports = __webpack_public_path__ + "media/28.06413029.mp3";